import { render, staticRenderFns } from "./Returno.vue?vue&type=template&id=2abb5d7e&"
import script from "./Returno.vue?vue&type=script&lang=js&"
export * from "./Returno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports